import {getDataWithPromise, getParamList, Globals, handleAjaxError, preProcessForm} from "./BaseDataFns";

export const getChildDetails= ( child_id, flags, onComplete ) =>
{
    const paramList = getParamList( flags, '?') ;

    const url = Globals.APIFolder + '/children/' + child_id + '?include-needs&include-flags&include-esw' ;

    getDataWithPromise (url, 'GET', {})
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const getYearFourteenChildrenWithPromise = () =>
{
    const url = Globals.APIFolder + '/children/year14plus' ;

    return getDataWithPromise (url, 'GET') ;
}

export const removeChildFromLAC = ( child_id, data ) =>
{
    // We have dates in there, so convert to dd/mm/yyyy format
    preProcessForm ( data ) ;

    const url = Globals.APIFolder + '/children/' + child_id + '/endlac2' ;

    return getDataWithPromise (url, 'POST', data) ;
}

export const getChildDetailsWithPromise = ( child_id, flags ) =>
{
    const paramList = getParamList( flags, '?') ;

    const url = Globals.APIFolder + '/children/' + child_id + '?include-needs&include-flags&include-esw' ;

    return getDataWithPromise (url, 'GET', {}) ;
}

export const getChildDetailsWithPromiseForReview = ( child_id, flags ) =>
{
    const paramList = getParamList( flags, '?') ;

    const url = Globals.APIFolder + '/children/' + child_id + paramList ;

    return getDataWithPromise (url, 'GET', {}) ;
}

export const getChildDocuments = ( child_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/documents' ;

    getDataWithPromise (url, 'GET', {})
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const getChildPreparingForAdulthood = ( child_id, year_group_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/adulthood/yeargroup/' + year_group_id ;

    getDataWithPromise (url, 'GET', {})
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const updatePreparingForAdulthood = ( child_id, indata, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/adulthood' ;

    const postData = { data: indata }

    getDataWithPromise ( url, 'PUT', postData )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const updateChildMultiplicationResults = ( child_id, indata, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/multiplication' ;

    getDataWithPromise ( url, 'PUT', indata )
   .then (response =>
   {
       onComplete (response) ;
   })
   .catch( (jqXHR, textStatus, error) =>
   {
       handleAjaxError( jqXHR, textStatus, error) ;
   });
}

export const unlinkChildDocument = ( child_id, document_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/documents/' + document_id ;

    getDataWithPromise (url, 'DELETE', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const transferChildrenToESW = ( data, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/transfer' ;

    getDataWithPromise (url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildPhonics = ( child_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/phonics' ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getPhonicsDetails = ( child_id, phonics_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/phonics/' + phonics_id ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updatePhonicsDetails = ( child_id, phonics_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/phonics/' + phonics_id ;

    const postData = { phonics_data: data }

    getDataWithPromise ( url, 'PUT', postData )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const createPhonicsForChild = ( child_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/phonics' ;

    const postData = { phonics_data: data }

    getDataWithPromise ( url, 'POST', postData )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const deletePhonicsForChild = ( child_id, child_sdq_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/sdq/' + child_sdq_id ;

    getDataWithPromise ( url, 'DELETE', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildRAGStatus = ( child_id, rag_status, onComplete ) =>
{
    const url = Globals.APIFolder  + '/children/'+child_id+'/rag/' + rag_status ;

    getDataWithPromise ( url, 'PUT', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildDetails = ( child_id, form_data, onComplete ) =>
{
    const url = Globals.APIFolder  + '/children/'+child_id+'/form' ;

    getDataWithPromise ( url, 'PUT', form_data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const reinstateChild = ( child_id, form_data, onComplete ) =>
{
    const url = Globals.APIFolder  + '/children/' + child_id + '/reinstate2' ;

    getDataWithPromise ( url, 'POST', form_data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const createChild = ( form_data, onComplete ) =>
{
    const url = Globals.APIFolder  + '/children/new3' ;

    getDataWithPromise ( url, 'POST', form_data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const fuzzyChildSearch = ( form_data, onComplete ) =>
{
    const url = Globals.APIFolder  + '/children/search' ;

    getDataWithPromise ( url, 'POST', form_data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getOfficialCohortCount = (onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/officialcohort' ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildrenInCareCount = (onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/childrenincare' ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getRegistrationSubmissions = (onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/registration' ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildStatusOnEnteringCare = ( child_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/statusonenteringcare2' ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildStatusOnEnteringCare = ( child_id, data, onComplete ) =>
{
    // We have dates in there, so convert to dd/mm/yyyy format
    preProcessForm ( data ) ;

    const url = Globals.APIFolder + '/children/' + child_id + '/statusonenteringcare2' ;

    getDataWithPromise (url, 'PUT', data)
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildDesiTeacher = ( child_id, formData, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/teachers' ;

    getDataWithPromise (url, 'POST', formData )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildAttendance = ( child_id, formData, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/attendance';

    getDataWithPromise (url, 'PUT', { attendance: formData} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}


export const getChildNotes = ( child_id, note_group_type = 1, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/notes/group/' + note_group_type ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildNoteDetails = ( child_id, child_note_type_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/notes/' + child_note_type_id ;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildNote = ( child_id, child_note_type_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/notes/' + child_note_type_id ;

    getDataWithPromise (url, 'PUT', data)
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}